import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Business Ownership Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const BusinessOwnershipView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="business-ownership"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default BusinessOwnershipView;
